import { render, staticRenderFns } from "./LabelsPicker.vue?vue&type=template&id=7ea5dba6&"
import script from "./LabelsPicker.vue?vue&type=script&lang=ts&"
export * from "./LabelsPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports